import type { EduCoursePayment, EduCoursePaymentEntity } from '@common/types/payment-form.type';

import { Injectable } from '@angular/core';
import { EPaymentType } from '@common/enums';

@Injectable({
    providedIn: 'root',
})
export class EduCoursePaymentsService {
    // YooKassa, Fondy, PayPal, YooMoney, ROBOKASSA, Stripe, MERCADOPAGO, LiqPay, Wayforpay, Flutterwave

    public mapEduCoursePaymentsToEduCoursePaymentEntities(
        eduCoursePayments: EduCoursePayment[]
    ): EduCoursePaymentEntity[] {
        return eduCoursePayments.map((eduCoursePayment: EduCoursePayment) =>
            this.mapEduCoursePaymentToEduCoursePaymentEntity(eduCoursePayment)
        );
    }

    public mapEduCoursePaymentToEduCoursePaymentEntity(eduCoursePayment: EduCoursePayment): EduCoursePaymentEntity {
        return {
            id: eduCoursePayment.paymentId,
            name: eduCoursePayment.name,
            currency: eduCoursePayment.currency,
            price: eduCoursePayment.price,
            isDefault: eduCoursePayment.isDefault,
            type: this.formatEduPaymentMethodType(eduCoursePayment.paymentType),
            eduPaymentMethodId: eduCoursePayment.id,
            courseTariffId: eduCoursePayment.courseTariffId,
        };
    }

    private formatEduPaymentMethodType(type: string): EPaymentType {
        const paymentTypeMap = {
            YooKassa: EPaymentType.youKassa,
            Fondy: EPaymentType.fondy,
            PayPal: EPaymentType.payPal,
            YooMoney: EPaymentType.yooMoney,
            ROBOKASSA: EPaymentType.roboKassa,
            Stripe: EPaymentType.stripe,
            MERCADOPAGO: EPaymentType.mercadopago,
            LiqPay: EPaymentType.liqpay,
            Wayforpay: EPaymentType.wayforpay,
            Flutterwave: EPaymentType.flutterwave,
            Monobank: EPaymentType.monobank,
            Cryptomus: EPaymentType.cryptomus,
            Whitepay: EPaymentType.whitepay,
            Klarna: EPaymentType.klarna,
            StripeConnect: EPaymentType.stripeConnect,
            RozetkaPay: EPaymentType.rozetkaPay,
            NovaPay: EPaymentType.novaPay,
        };

        if (paymentTypeMap[type]) {
            return paymentTypeMap[type];
        }

        return null;
    }
}
